module.exports = __webpack_public_path__ + "img/nol.6f870d71.png";